import * as CookieConsent from 'vanilla-cookieconsent';

const CAT_NECESSARY = 'necessary';
const CAT_ANALYTICS = 'analytics';
const CAT_ADVERTISING = 'advertising';
const CAT_FUNCTIONALITY = 'functionality';

function updateGtagConsent() {
    if (typeof gtag !== 'function') {
        return;
    }

    gtag('consent', 'update', {
        analytics_storage: CookieConsent.acceptedCategory(CAT_ANALYTICS) ? 'granted' : 'denied',
        ad_storage: CookieConsent.acceptedCategory(CAT_ADVERTISING) ? 'granted' : 'denied',
        ad_user_data: CookieConsent.acceptedCategory(CAT_ADVERTISING) ? 'granted' : 'denied',
        ad_personalization: CookieConsent.acceptedCategory(CAT_ADVERTISING) ? 'granted' : 'denied',
        functionality_storage: CookieConsent.acceptedCategory(CAT_FUNCTIONALITY) ? 'granted' : 'denied',
        personalization_storage: CookieConsent.acceptedCategory(CAT_FUNCTIONALITY) ? 'granted' : 'denied',
    });

    window.dispatchEvent(new CustomEvent('lpdg:consent', {
        detail: {
            analytics: CookieConsent.acceptedCategory(CAT_ANALYTICS),
            advertising: CookieConsent.acceptedCategory(CAT_ADVERTISING),
            functionality: CookieConsent.acceptedCategory(CAT_FUNCTIONALITY),
        },
    }));
}

window.CookieConsent = CookieConsent;

window.lpdgShowCookiePreferences = function () {
    CookieConsent.showPreferences();
};

function initCookieConsent() {
    CookieConsent.run({
        guiOptions: {
            consentModal: {
                layout: 'box',
                position: 'bottom left',
                equalWeightButtons: true,
                flipButtons: false,
            },
            preferencesModal: {
                layout: 'box',
                position: 'right',
                equalWeightButtons: true,
                flipButtons: false,
            },
        },
        categories: {
            [CAT_NECESSARY]: {
                enabled: true,
                readOnly: true,
            },
            [CAT_ANALYTICS]: {
                autoClear: {
                    cookies: [
                        { name: /^_ga/ },
                        { name: '_gid' },
                    ],
                },
            },
            [CAT_ADVERTISING]: {
                autoClear: {
                    cookies: [
                        { name: /^_gcl_/ },
                        { name: '_fbp' },
                        { name: '_fbc' },
                    ],
                },
            },
            [CAT_FUNCTIONALITY]: {},
        },
        language: {
            default: 'fr',
            translations: {
                fr: {
                    consentModal: {
                        title: 'Nous utilisons des témoins',
                        description: 'Ce site utilise des témoins essentiels pour assurer son bon fonctionnement et des témoins de suivi pour comprendre comment vous l\'utilisez. Ces derniers ne seront activés qu\'avec votre consentement, conformément à la Loi 25.',
                        acceptAllBtn: 'Tout accepter',
                        acceptNecessaryBtn: 'Tout refuser',
                        showPreferencesBtn: 'Personnaliser',
                    },
                    preferencesModal: {
                        title: 'Gérer mes préférences de témoins',
                        acceptAllBtn: 'Tout accepter',
                        acceptNecessaryBtn: 'Tout refuser',
                        savePreferencesBtn: 'Enregistrer mes choix',
                        closeIconLabel: 'Fermer',
                        serviceCounterLabel: 'Service|Services',
                        sections: [
                            {
                                title: 'Utilisation des témoins',
                                description: 'Nous utilisons des témoins pour assurer les fonctionnalités de base du site et améliorer votre expérience en ligne.',
                            },
                            {
                                title: 'Témoins strictement nécessaires',
                                description: 'Ces témoins sont essentiels au bon fonctionnement du site et ne peuvent pas être désactivés.',
                                linkedCategory: CAT_NECESSARY,
                            },
                            {
                                title: 'Analytique',
                                description: 'Ces témoins nous permettent de mesurer l\'audience et d\'améliorer le contenu du site (Google Analytics 4).',
                                linkedCategory: CAT_ANALYTICS,
                            },
                            {
                                title: 'Publicité',
                                description: 'Ces témoins permettent de mesurer l\'efficacité de nos campagnes publicitaires et d\'afficher des annonces pertinentes (Google Ads, Meta).',
                                linkedCategory: CAT_ADVERTISING,
                            },
                            {
                                title: 'Fonctionnalité',
                                description: 'Ces témoins permettent de mémoriser vos préférences et d\'améliorer certaines fonctionnalités du site.',
                                linkedCategory: CAT_FUNCTIONALITY,
                            },
                        ],
                    },
                },
            },
        },
        onFirstConsent: updateGtagConsent,
        onConsent: updateGtagConsent,
        onChange: updateGtagConsent,
    });
}

if (document.body) {
    initCookieConsent();
} else {
    document.addEventListener('DOMContentLoaded', initCookieConsent);
}
